import * as React from 'react'
import { styled } from '../../theme/styled'
import { Backdrop, BackdropProps, Typography } from '@mui/material'
import { Loader } from '../Loader'

export interface BlockingLoaderProps extends BackdropProps {
  message?: any
  color?: string
}

const BackdropCustom = styled(Backdrop)`
  z-index: 100000;
`
const Container = styled.div`
  padding: 2rem;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
`

const LoaderContainer = styled.div`
  margin-bottom: 1rem;
`

const MessageBlock = styled(Typography)<{ $color?: string }>`
  color: ${(p) => (p.$color ? p.$color : p.theme.av8.secondaryColor)};
  text-align: center;
`

const ChildrenContainer = styled.div`
  margin-top: 1rem;
`

export const BlockingLoader = (props: BlockingLoaderProps) => {
  const { message, color, children, ...rest } = props
  return (
    <BackdropCustom {...rest}>
      <Container>
        <LoaderContainer>
          <Loader color={color} />
        </LoaderContainer>
        {message && (
          <MessageBlock variant='body2' $color={color}>
            {message}
          </MessageBlock>
        )}
        {children && <ChildrenContainer>{children}</ChildrenContainer>}
      </Container>
    </BackdropCustom>
  )
}
